<template>
  <v-chip-group multiple column 
    v-bind="$attrs"
    @change="$listeners.input"
    active-class="primary"
  >
    <v-chip small v-for="t in trades" :key="t.trade_id" :value="t.trade_id">
      {{ t.name }}
    </v-chip>
  </v-chip-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('trades', ['trades']),
  },

  methods: {
    ...mapActions('trades', ['loadTrades']),
  },

  created() {
    this.loadTrades()
  },
}
</script>